import React from 'react'

import { MainLayout } from 'src/common/layouts/MainLayout/MainLayout'
import { ArticleClientType } from 'src/strapi/types/articleTypes'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import { ArticleBrowseOther } from './ArticleBrowseOther/ArticleBrowseOther'
import { ArticleGetMatchedBlock } from './ArticleGetMatchedBlock/ArticleGetMatchedBlock'
import { ArticleMain } from './ArticleMain/ArticleMain'
import { ArticleMeta } from './ArticleMeta/ArticleMeta'

export type ArticlePageProps = {
  article: ArticleClientType
  recommendedArticles: Array<ArticleClientType>
}

export const ArticlePage: React.FC<ArticlePageProps> = ({
  article,
  recommendedArticles,
}) => {
  const { analytic } = useAnalytic()
  analytic.event(AnalyticEventEnum.ARTICLE_PAGE)

  return (
    <>
      <ArticleMeta articleTitle={article.title} />

      <MainLayout pageAnalytic={'article'}>
        <ArticleMain article={article} />
        <ArticleBrowseOther articles={recommendedArticles} />
        <ArticleGetMatchedBlock />
      </MainLayout>
    </>
  )
}
